// extracted by mini-css-extract-plugin
export default {"wrapper":"Orders_wrapper__yApe6","list":"Orders_list__wx9SR","list-three":"Orders_list-three__1lLf3","item":"Orders_item__oKu86"};